// extracted by mini-css-extract-plugin
export var modal = "_gw-0";